<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Rapatriement états financiers existants</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }">Tableau de bord</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link :to="{ name: 'classeurs' }">Rapatriement états financiers existants</router-link>
          </li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h3 class="card-title fw-bold mb-0">Rapatriement états financiers existants </h3>
            <div class="card-options">
              <div class="btn-group">
                <div class="d-flex gap-2">
                  <button
                      class="btn btn-primary btn-sm"
                      @click="importedData.length ? resetData() : displayFomUpload()"
                  >
                    <i :class="importedData.length ? 'fe fe-refresh me-1' : 'fe fe-upload me-1'"></i>
                    {{ importedData.length ? 'Reset' : 'Charger' }}
                  </button>
                  <button class="btn btn-primary btn-sm" @click="telechargerModeleExcel">
                    <i class="fe fe-download me-1"></i> Télécharger modèle
                  </button>
                  <button
                      class="btn btn-success"
                      v-if="!hasAnyErrors && importedData.length"
                      :disabled="hasAnyErrors || !importedData.length"
                      @click="saveAll"
                  >
                    Enregistrer tout
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">


            <!-- Centrage -->
            <div class="d-flex  justify-content-center  mb-3"  v-if="importedData.length > 0">
              <div class="form-horizontal" >
                <div class=" row mb-4">
                  <label class="col-md-3 form-label">Année : </label>
                  <div class="col-md-9">
                    <multi-select
                        deselect-label="Sélectionné"
                        disabled
                        select-label=""
                        :options="exercices"
                        placeholder="XXXX"
                        label="annee"
                        track-by="annee"
                        :searchable="true"
                        :custom-label="o => o.annee"
                        v-model="payload.exercice"
                        style="min-width: 250px"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.annee }}</strong>
                      </template>
                      <span slot="noOptions">
        <strong>Liste Vide</strong>
      </span>
                      <span slot="noResult">
        <strong>Aucun Résultat</strong>
      </span>
                    </multi-select>
                  </div>
                </div>
              </div>

            </div>
            <div class="table-responsive">
              <table class="table table-hover table-bordered text-nowrap mb-0">
                <thead class="border-top success02">
                <tr>
                  <th>N°</th>
                  <th>ID PTA ASIN</th>
                  <th>ID Budget</th>
                  <th>Report BN</th>
                  <th>Report PRET</th>
                  <th>Report DON</th>
                  <th>Report ANT</th>
                  <th>Report BA</th>
                  <th>Total Report</th>
                </tr>
                </thead>
                <tbody v-if="importedData.length > 0" id="myTable1">
                <tr
                    v-for="(row, index) in paginatedData"
                    :key="index"
                    :class="{ 'bg-danger-transparent': hasRowErrors(row) }"
                >
                  <td>{{ (currentPage - 1) * itemsPerPage + index + 1 }}</td>
                  <td>
                    {{ row.id_pta_asn }}
                    <span v-if="row.errors?.id_pta_asn" class="badge bg-danger ms-1">{{ row.errors.id_pta_asn }}</span>
                  </td>
                  <td>{{ row.id_budget }}
                    <span v-if="row.errors?.id_budget" class="badge bg-danger ms-1">{{ row.errors.id_budget }}</span></td>
                  <td>
                    {{ row.report_bn }}
                    <span v-if="row.errors?.report_bn" class="badge bg-danger ms-1">{{ row.errors.report_bn }}</span>
                  </td>
                  <td>{{ row.report_pret }}
                    <span v-if="row.errors?.report_pret" class="badge bg-danger ms-1">{{ row.errors.report_pret }}</span>
                  </td>
                  <td>{{ row.report_don }}
                    <span v-if="row.errors?.report_don" class="badge bg-danger ms-1">{{ row.errors.report_don }}</span>
                  </td>
                  <td>{{ row.report_ant }}
                    <span v-if="row.errors?.report_ant" class="badge bg-danger ms-1">{{ row.errors.report_ant }}</span>
                  </td>
                  <td>{{ row.report_ba }}
                    <span v-if="row.errors?.report_ba" class="badge bg-danger ms-1">{{ row.errors.report_ba }}</span>
                  </td>
                  <td>
                    {{ row.total_report }}
                    <span v-if="row.errors?.total_report" class="badge bg-danger ms-1">{{ row.errors.total_report }}</span>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="primary02">
                  <td colspan="9" class="text-center">Aucune donnée trouvée</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-if="importedData.length > 0" class="mt-3 d-flex justify-content-between align-items-center">
              <button class="btn btn-sm btn-primary" @click="currentPage--" :disabled="currentPage === 1">Précédent</button>
              <span>Page {{ currentPage }} / {{ totalPages }}</span>
              <button class="btn btn-sm btn-primary" @click="currentPage++" :disabled="currentPage === totalPages">Suivant</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade"  id="modal-upload-form" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form class="w-100" @submit.prevent="handleFormSubmit">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">Upload</h6><button aria-label="Close" class="btn-close text-white"
                                                                                                           data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
          </div>

          <div class="modal-body">
                <div class="control-group form-group mb-0">
                  <ValidationProvider name="Année" rules="required" v-slot="{ errors }">
                    <label class="form-label">Année <span class="text-danger">*</span></label>
                    <multi-select  deselect-label="Sélectionné" select-label=""
                                   :options="exercices"
                                   placeholder="Sélectionné une année " label="annee"
                                   track-by="annee" :searchable="true"
                                   :custom-label="o => o.annee"
                                   v-model="payload.exercice">
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong> {{ option.annee }}</strong>
                      </template>
                      <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                      <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                    </multi-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
            <div class="control-group form-group row mt-3">
              <div class="col-lg-12 col-sm-12">
                <ValidationProvider name="Fichier Excel" rules="required" v-slot="{ errors }" ref="excelFileProvider">
                  <label class="form-label">Uploader un fichier Excel <span class="text-danger">*</span></label>
                  <input
                      id="dropify-upload"
                      type="file"
                      class="dropify-fr"
                      data-height="180"
                      @change="onFileChange"
                      accept=".xls,.xlsx"
                      ref="excelFile"
                      data-allowed-file-extensions="xls xlsx"
                      data-show-errors="true"
                      data-show-loader="true"
                      data-max-file-size-preview="3M"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>
            </div>



          </div>
          <div class="modal-footer">
            <button class="btn btn-gray" type="button" data-bs-dismiss="modal">Fermer</button>
            <button type="submit" class="btn btn-primary" :disabled="invalid">Soumettre</button>
          </div>
            </form>
          </ValidationObserver>
        </div>

      </div>
    </div>

  </div>
</template>

<script>


  import * as ExcelJS from "exceljs";
  import { saveAs } from 'file-saver';

  export default {
    name: "RapatriementEF",
    data() {
      return {
        payload: {
          exercice: null,
          fichier: null,
        },
        exercices : [],
        currentPage: 1,
        itemsPerPage: 10,
        importedData: []
      }
    },
    mounted() {
    },
    computed: {
      paginatedData() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return this.importedData.slice(start, start + this.itemsPerPage);
      },
      totalPages() {
        return Math.ceil(this.importedData.length / this.itemsPerPage);
      },
      hasAnyErrors() {
        return this.importedData.some(row => row.errors && Object.keys(row.errors).length > 0);
      }
    },
    methods : {
      resetData() {
        // Annuler le fichier importé (si tu stockes un fichier dans data, réinitialise-le aussi)
        this.importedData = [];
        // Si tu as un input file, reset sa valeur (optionnel)
        const fileInput = this.$refs.fileInput;
        if (fileInput) fileInput.value = null;
      },
      saveAll() {
        const payload = {
          year: this.payload.exercice.annee,
          data: this.importedData
        };

        this.$http.post('/importSuccessHist', payload)
            .then(async ({ data }) => {

              this.resetData();
              this.$loading(false)
              swal('Information!', 'Sauvegarde  effectué avec succès.', 'success');

            })
            .catch((error) => {
              swal('Information!', 'Une erreur est survenue lors de la sauvegarde. ' + error, 'warning');
            })
            .finally(() => this.$loading(false));
        // Exemple simple, à adapter à ton besoin
        console.log("Enregistrement des données valides...");
        // Tu peux faire un appel API ici
      },
      hasRowErrors(row) {
        return row.errors && Object.keys(row.errors).length > 0;
      },
      displayFomUpload(){
        $('#modal-upload-form').modal('show');
      },
      onFileChange(event) {
        const file = event.target.files[0];
        this.payload.fichier = file || null;
      },
      async handleFormSubmit() {
        this.$loading(true);
        const file = this.payload.fichier;

        console.log("Headers nettoyés :", this.payload.fichier);

        if (!file || !(file instanceof File)) {
          swal('Information !', "Veuillez sélectionner un fichier Excel.");
          this.$loading(false);
          return;
        }

        const extension = file.name.split('.').pop().toLowerCase();
        const allowedExtensions = ['xls', 'xlsx'];

        if (!allowedExtensions.includes(extension)) {
          swal('Erreur !', "Le fichier doit être un Excel (.xls ou .xlsx).");
          this.$loading(false);
          return;
        }

        try {
          const workbook = new ExcelJS.Workbook();
          const reader = new FileReader();

          const normalize = (str) => str.toLowerCase().replace(/\s+/g, '');


          reader.onload = async (e) => {
            const buffer = e.target.result;
            await workbook.xlsx.load(buffer);
            const worksheet = workbook.getWorksheet('Modèle') || workbook.worksheets[0];
            if (!workbook.getWorksheet('Modèle')) {
              console.warn("⚠️ Feuille 'Modèle' non trouvée. Utilisation de la première feuille :", worksheet.name);
            }

            console.log("worksheet ");

            let rawHeaders = worksheet.getRow(1).values.slice(1);
            const headers = rawHeaders
                .map(h => (h ? h.toString().trim() : null))
                .filter(h => h !== null && h !== '');

            console.log("Headers nettoyés :", headers);


            const data = [];

            worksheet.eachRow((row, rowNumber) => {
              if (rowNumber === 1) return; // ignorer l’en-tête

              const rowData = {};
              const rowErrors = {};
              const values = row.values.slice(1); // idem

              const normalizedMapping = {
                'idptaasin': 'id_pta_asn',
                'idbudget': 'id_budget',
                'reportbn': 'report_bn',
                'reportpret': 'report_pret',
                'reportdon': 'report_don',
                'reportant': 'report_ant',
                'reportba': 'report_ba',
                'totalreport': 'total_report'
              };

              headers.forEach((header, i) => {
                const normalizedHeader = normalize(header);
                const key = normalizedMapping[normalizedHeader];

                if (!key) {
                  console.warn(`⚠️ Colonne inconnue ignorée : "${header}"`);
                  return;
                }

                let value = values[i];

                if (typeof value === 'object' && value !== null) {
                  value = value.text ?? '';
                }

                value = (value ?? '').toString().trim();

                if (!value) {
                  rowData[key] = null;
                  rowErrors[key] = `${header} est requis`;
                  return;
                }

                // 🔍 Validation
                if (key === 'id_pta_asn') {
                  rowData[key] = value;
                } else if (key === 'id_budget') {
                  const parsed = parseFloat(value);
                  rowData[key] = isNaN(parsed) ? null : parsed;
                  if (isNaN(parsed) || parsed < 0) {
                    rowErrors[key] = "ID Budget doit être un nombre positif";
                  }
                } else if (['report_bn', 'report_pret', 'report_pret', 'report_ant', 'report_ba'].includes(key)) {
                  const parsed = parseFloat(value);
                  rowData[key] = isNaN(parsed) ? null : parsed;
                  if (isNaN(parsed) || parsed < 0) {
                    rowErrors[key] = `${header} doit être un nombre positif`;
                  }
                } else if (key === 'total_report') {
                  const parsed = parseFloat(value);
                  rowData[key] = isNaN(parsed) ? null : parsed;
                  if (isNaN(parsed) || parsed < 0) {
                    rowErrors[key] = "Total Report doit être un nombre positif";
                  }
                } else {
                  const parsed = parseFloat(value);
                  rowData[key] = isNaN(parsed) ? null : parsed;
                  if (isNaN(parsed) || parsed < 0) {
                    rowErrors[key] = `${header} invalide ou manquant`;
                  }
                }
              });



              data.push({ ...rowData, errors: rowErrors });
            });

            this.importedData = data;

            $('#modal-upload-form').modal('hide');
            console.log('📄 Données mappées :', data);

            // Vérifier si au moins une erreur dans data
            const hasErrors = data.some(row => Object.keys(row.errors).length > 0);

            if (hasErrors) {
              swal({
                title: 'Erreurs détectées',
                text: 'Veuillez corriger les erreurs dans le fichier puis le soumettre à nouveau.',
                icon: 'error',
                button: 'OK',
              });
              this.$loading(false);
            } else {
              swal({
                title: 'Succès',
                text: 'Le fichier est valide et prêt à être envoyé !',
                icon: 'success',
                button: 'Continuer',
              });
              // Ici tu peux envoyer les données au backend par exemple
              this.$loading(false);
            }
          };

          reader.readAsArrayBuffer(file);

        } catch (error) {
          console.error(error);
          swal('Erreur', "Une erreur est survenue lors de l’analyse du fichier.");
          this.$loading(false);
        }
      },


      async telechargerModeleExcel() {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Modèle');

        // ✅ Définir les colonnes avec en-têtes
        worksheet.columns = [
          { header: 'ID PTA ASIN', key: 'id_pta_asn', width: 15 },
          { header: 'ID Budget', key: 'id_budget', width: 20 },
          { header: 'Report BN', key: 'report_bn', width: 15 },
          { header: 'Report PRET', key: 'report_pret', width: 15 },
          { header: 'Report DON', key: 'report_don', width: 15 },
          { header: 'Report ANT', key: 'report_ant', width: 15 },
          { header: 'Report BA', key: 'report_ba', width: 15 },
          { header: 'Total Report', key: 'total_report', width: 20 },
        ];

        // ✅ Ajouter une ligne vide
        worksheet.addRow({});

        // ✅ Appliquer un style à l’en-tête
        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF0070C0' }, // Bleu foncé
          };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.border = {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          };
        });

        // ✅ Figer la première ligne
        worksheet.views = [
          { state: 'frozen', ySplit: 1 }
        ];

        worksheet.getColumn('report_bn').eachCell({ includeEmpty: true }, (cell, rowNumber) => {
          if (rowNumber > 1) {
            cell.dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: ['"OUI,NON"'],
              showInputMessage: true,
              promptTitle: 'Valeur attendue',
              prompt: 'Choisir entre OUI ou NON',
            };
          }
        });

        worksheet.getColumn('id_pta_asn').eachCell({ includeEmpty: true }, (cell, rowNumber) => {
          if (rowNumber > 1) {
            const cellAddress = `A${rowNumber}`; // A = colonne 1 (ID PTA)
            cell.dataValidation = {
              type: 'custom',
              formulae: [`LEN(${cellAddress})>0`],
              showErrorMessage: true,
              errorTitle: 'Champ obligatoire',
              error: 'Le champ ID PTA ne peut pas être vide.',
              showInputMessage: true,
              promptTitle: 'Valeur requise',
              prompt: 'Saisir une valeur pour ID PTA',
            };
          }
        });

        // Numérique uniquement pour Total Report
        worksheet.getColumn('total_report').eachCell({ includeEmpty: true }, (cell, rowNumber) => {
          if (rowNumber > 1) {
            cell.dataValidation = {
              type: 'decimal',
              operator: 'greaterThanOrEqual',
              formulae: [0],
              showErrorMessage: true,
              errorTitle: 'Erreur de saisie',
              error: 'Veuillez entrer un NOMBRE positif uniquement.',
              showInputMessage: true,
              promptTitle: 'Valeur attendue',
              prompt: 'Saisir un nombre (ex: 1250.00)',
            };
          }
        });

        // ✅ Générer le fichier et déclencher le téléchargement
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'modele_rapatriement.xlsx');
      },
      getExercices() {
        this.$loading(true);
        this.$http.get('/exercice')
            .then(({data}) => {
              console.log(data);
              console.log(1);
              this.exercices = data;
              this.$loading(false);

            });
      },
    },
    created() {

      this.getExercices()


    },
  }
</script>
